export default {
  API: Symbol('API'),
  NETWORK: Symbol('NETWORK'),
  TIMEOUT: Symbol('TIMEOUT'),
};
